
import { useState } from 'react';
import { profileTypeMapping } from '@/utils/profileTypeMapping';

export type ProfileOverrideType = keyof typeof profileTypeMapping | null;

export const useProfileOverride = (initialOverride: ProfileOverrideType = null) => {
  const [profileOverride, setProfileOverride] = useState<ProfileOverrideType>(initialOverride);

  const clearOverride = () => setProfileOverride(null);

  // Get all available profile options with their display names
  const getProfileOptions = () => {
    const profiles = Object.entries(profileTypeMapping).map(([key, value]) => ({
      value: key as keyof typeof profileTypeMapping,
      label: value.type
    }));

    return [
      { value: null, label: 'Auto (Calculated)' },
      ...profiles.sort((a, b) => a.label.localeCompare(b.label))
    ];
  };

  const getProfileDisplayName = (profileKey: keyof typeof profileTypeMapping) => {
    return profileTypeMapping[profileKey]?.type || 'Unknown';
  };

  return {
    profileOverride,
    setProfileOverride,
    clearOverride,
    getProfileOptions,
    getProfileDisplayName
  };
};
